<template>
    <div class="fixed-scroller" style="z-index:100">

    
    
    <div class="v-alert create-ad w-1100" style="top: 80px;z-index: 100;">
        <header><p>Edit Card</p><div class="x" @click="$emit('emit',{ t: 'edit-card', action: 'exit' })"></div></header>
        <div class="edit-ad-container" :class="{ 'no-boxes': hideBoxes }">
            <div class="left">
                <div :class="['background',{ selected: selectFront }]" :style="{ backgroundColor: ad.backgroundColor, color: ad.fontColor, height: (ad.height * scale)+'px' }">
                    <div class="ad-box" style="width: 414px;height: 100%;">
                        <img v-if="ad.src" :src="ad.src" width="100%" class="upload" />
                        <div class="ad-btns">
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="(btn,i) in ad.btns.filter(b => !b.reverse)" :key="i">
                                <component :is="btn.component" :btn="btn" class="ad-btn" :class="{ selected: btn.selected }" :style="btn.style"></component>
                            </div>    
                            <!--
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="btn in ad.btns.filter(b => !b.reverse)" :class="['ad-btn',{ selected: btn.selected },'type-'+btn.action]" :style="btn.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'">
                                <img v-if="btn.type == 'image'" :src="btn.src" style="width:100%" />
                                <video v-if="btn.type == 'video'" :id="btn.code" :src="btn.mov"  controls="true" width="100%" height="100%"></video>
                                <img v-if="btn.type == 'qr'" src="https://api.survey-vip.com/qr?id=httpsasdfsadfsadfasdfsomerandomdataorother" width="100%" />
                                <div v-if="btn.type == 'video'" style="position: absolute;top:0px;left:0px;width: 100%;height: 100%;"></div>
                                <p v-if="btn.type == 'text'" :class="btn.css" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor }" style="width: 100%;" v-html="btn.value"></p>
                            </div>
                            -->
                        </div>                        
                    </div>  
                </div>
                <div v-if="ad.backface || ad.btns.find(b => b.reverse)" :class="['backface',{ selected: selectBack }]" :style="{ backgroundColor: ad.backgroundColor, color: ad.fontColor,height: (ad.height * scale)+'px' }">
                    <div class="ad-box" style="width: 414px;" :style="{ backgroundColor: ad.backgroundColor, color: ad.fontColor }">
                        <img v-if="ad.backface" :src="ad.backface" width="100%" class="upload" />
                        <div class="ad-btns">
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="(btn,i) in ad.btns.filter(b => b.reverse)" :key="i">
                                <component :is="btn.component" :btn="btn" class="ad-btn" :class="{ selected: btn.selected }" :style="btn.style"></component>
                            </div> 

                            <!-- 
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="btn in ad.btns.filter(b => b.reverse)" :class="['ad-btn',{ selected: btn.selected },'type-'+btn.action]" style="font-size:28px;display:flex;align-items:center;justify-content:space-around;">
                                <img v-if="btn.type == 'image'" :src="btn.src" :style="btn.style" />
                                <video :id="btn.code" v-if="btn.type == 'video'"  :src="btn.mov"  controls="true" width="100%" height="100%"></video>
                                <img v-if="btn.type == 'qr'" src="https://api.survey-vip.com/qr?id=httpsasdfsadfsadfasdfsomerandomdataorother" width="100%" />
                                <div v-if="btn.type == 'video'" style="position: absolute;top:0px;left:0px;width: 100%;height: 100%;"></div>
                                <p v-if="btn.type == 'text'" :class="btn.css" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor }" style="width: 100%;" v-html="btn.value"></p>
                            </div>
                            -->

                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="label w-50" style="height:0px">
                    <p>Title</p>
                    <input v-model="ad.title" />
                </div>
                <div class="label w-50">
                    <p>Category</p>
                    <select v-model="ad.cat"><option v-for="cat in cats">{{ cat }}</option></select>
                </div>
                <div class="label w-50" style="margin-bottom: 0px;">

                    <div class="label w-33" style="margin: 0px 0px 0px 0px;width: calc(33% + 0px);">
                        <p>Background</p>
                        <div class="color-box">
                            <input type="color" style="padding: 0px;" v-model="ad.backgroundColor" />
                            <input v-model="ad.backgroundColor" />
                        </div>
                    </div>
                    <div class="label w-33" style="margin: 0px 0px 0px 10px;width: calc(33% + 0px);">
                        <p>Font</p>
                        <div class="color-box">
                            <input type="color" style="padding:0px" v-model="ad.fontColor" />
                            <input v-model="ad.fontColor" />
                        </div>
                    </div>
                </div>
                <div style="width:100%;float:left">
                <div class="label w-50">
                    <p>Refresh Offer</p>
                    <input type="checkbox" v-model="ad.isBottomless" @change="updateBottomless(ad,$event)" />
                    <select class="bottomless-select" v-if="!ad.redeemAd" v-model="ad.bottomless" @change="updateAdBottomLess(ad,ad.bottomless)"><option v-for="bottom in bottomless">{{ bottom }}</option></select>
                </div>
                <div class="label w-50">
                    <p>Expire</p>
                    <input v-model="ad.expireAd" type="checkbox" style="margin: 4px 0px;float: left;" @change="checkExpireAd" />
                    <p style="width: calc(100% - 51px);height:30px;border: 1px solid black;background-color:whitesmoke;line-height: 30px;padding: 0px 5px;position: relative;left:33px" @click="setExpire = true">{{ ad.u_expires }}</p>
                </div>
                </div>
                <div class="label w-50" style="margin-bottom: -5px;">
                    <p>Card Height</p>
                    <input v-model.number="ad.height" />
                </div>
                <div class="label w-50" style="opacity: 1;margin-bottom: 0px;">
                    <div class="label w-33">
                        <p>Hide Boxes</p>
                        <input type="checkbox" v-model="hideBoxes" />
                    </div>
                    <div class="label w-33">
                        <p class="btn" @click="ad.src = ''" style="position: relative;left:-20px;top: 12px">Delete Front</p>
                        
                    </div>
                    <div class="label w-33">
                        <p class="btn" @click="ad.backface = ''" style="position: relative;left:-12px;top: 12px">Delete Back</p>
                    </div>
                </div>
                <div class="label w-50">
                    <p>Button Type</p>
                    <select v-model="btnType"><option v-for="(btn,i) in types" :key="i">{{ btn.type }}</option></select>
                </div>

                <div class="label w-50">
                    <p v-if="btnType && btnType != 'qr'" class="btn" style="width: 177px;margin: 20px 0px 0px 0px" @click="addButton('front',btnType)">add {{ btnType }} front</p>
                    <p v-if="btnType" class="btn" style="width: 177px;margin: 20px 0px 0px 20px" @click="addButton('back',btnType)">add {{ btnType }} back</p>
                </div>
                <div class="label w-100" v-if="ad.btns.length > 0">
                    <p>Buttons</p>
                    <div class="btn-list">
                        <p></p>
                        <p>Type</p>
                        <p>Side</p>
                        <p>Left</p>
                        <p>Top</p>
                        <p>Width</p>
                        <p>Height</p>
                    </div>
                    <div v-for="btn in ad.btns" @keyup="updateBtn(btn)">
                        
                        <div v-if="!btn.selected" class="btn-list">
                            <p class="up-down" @click="moveBtnOrder(btn,$event)">
                                <span class="up" style="width:100%;height:50%;float: left;"></span>
                                <span class="down" style="width:100%;height:50%;float: left;"></span>
                            </p>
                            <p class="td-ulb" @click="selectBtn(btn)">{{ btn.type }}</p><p>{{ btn.reverse ? 'BACK' : 'FRONT' }}</p><p>{{ btn.left }}</p><p>{{ btn.top }}</p><p>{{ btn.width }}</p><p>{{ btn.height }}</p><div class="x" @click="ad.btns = ad.btns.filter(b => b != btn)"></div>
                        </div>
                        <div v-if="btn.selected" class="btn-list btn-selected">
                            <p class="up-down" @click="moveBtnOrder(btn,$event)">
                                <span class="up" style="width:100%;height:50%;float: left;"></span>
                                <span class="down" style="width:100%;height:50%;float: left;"></span>
                            </p>
                            <p class="td-ulb" @click="selectBtn(btn)">{{ btn.type }}</p>
                            <p>{{ btn.reverse ? 'BACK' : 'FRONT' }}</p>
                            <input v-model.number="btn.left" @keydown="updateKeyBtn(btn,'left',$event)" />
                            <input v-model.number="btn.top" @keydown="updateKeyBtn(btn,'top',$event)"/>
                            <input v-model.number="btn.width" @keydown="updateKeyBtn(btn,'width',$event)"/>
                            <input :style="{ opacity: ['image'].indexOf(btn.type) == -1 ? 1 : 0 }"v-model.number="btn.height" @keydown="updateKeyBtn(btn,'height',$event)"/>
                            <div class="x" @click="ad.btns = ad.btns.filter(b => b != btn)"></div>
                        </div>
                        <div v-if="btn.selected" class="btn-selected">
                            <div class="label" v-if="btn.type == 'video'" style="margin-left:0px;margin-top:0px">
                                <p>.mp4 URL</p>
                                <input v-model="btn.mov" placeholder="https://..." style="width:630px" />
                                <p class="btn" style="float:right;margin:1px 0px 0px 0px" @click="uploadVideo(btn)">Upload</p>
                            </div>
                            <div class="label" v-if="btn.type == 'gif'" style="margin-left:0px;margin-top:0px">
                                <p>.gif URL</p>
                                <input v-model="btn.gif" placeholder="https://..."/>
                            </div>
                            <div class="label" v-if="btn.type == 'terms'" style="margin-left:0px;margin-top:0px">
                                <p class="btn" @click="editTerms(btn)">EDIT TERMS</p>
                                <p></p>
                            </div>
                            <div class="label" v-if="btn.type == 'link'" style="margin-left:0px;margin-top:0px">
                                <p>Link URL</p>
                                <input v-model="btn.value" placeholder="https://..."/>
                            </div>
                            <div class="label" v-if="btn.type == 'text'" style="margin-left:0px;margin-top:0px">
                                <p>Enter Text</p>
                                <textarea v-model="btn.value" style="max-width:455px;min-width: 455px;float: left;height: 121px;"></textarea>
                                <div class="select-label">
                                    <p>Font Family</p>
                                    <select v-model="fontFamily" @change="updateBtnFont(btn)"><option v-for="font in fontFamilies">{{ font.font }}</option></select>
                                </div>
                                <div class="select-label">
                                    <p>Font Size</p>  
                                    <select v-model="btn.fontSize"><option v-for="fontsize in fontSizes">{{ fontsize }}</option></select>
                                </div>
                                <div class="select-label">
                                    <p>Line Height</p>
                                    <select v-model="btn.lineHeight"><option v-for="lineheight in [1,1.1,1.2,1.3,1.4,1.5,2,2.2,2.5,3]">{{ lineheight }}</option></select>
                                </div>
                                <div class="select-label">
                                    <p>Text Align</p>
                                    <select v-model="btn.textAlign"><option v-for="align in textAligns">{{ align }}</option></select>
                                </div>
                                <div class="select-label">
                                    <p>Background</p>
                                    <div class="color-box">
                                        <input type="color" style="padding: 0px;" v-model="btn.backgroundColor" />
                                        <input v-model="btn.backgroundColor" />
                                    </div>
                                </div>
                                <div class="select-label">
                                    <p>Font Color</p>
                                    <div class="color-box">
                                        <input type="color" style="padding: 0px;" v-model="btn.fontColor" />
                                        <input v-model="btn.fontColor" />
                                    </div>
                                </div>
                            </div>                              
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns" style="width: 1100px">
                <p class="btn" @click="save(ad)">SAVE</p>
            </div>
        </div>

        <div v-if="downloading" class="fixed-scroller downloading" @click="downloading = false" style="width:100%">
            <div class="bar">
                <div class="progress" :style="{ width: 'calc('+((downloading.progress / downloading.count) * 100 )+'% - 10px)' }"></div>
            </div>
        </div>
        <div v-if="setExpire" class="v-alert">
            <header><p>Set Card Expire</p><div class="x" @click="setExpire = false"></div></header>
            <div class="label">
                <p style="width:100px">Expires</p>
                <div class="date-time-box" @change="changeDate">
                    <div class="label w-50">
                        <p>Hr</p>
                        <select v-model="hour"><option v-for="Hr in hours">{{ Hr }}</option></select>
                    </div>
                    <div class="label w-50">
                        <p>Min</p>
                        <select v-model="minute"><option v-for="Min in minutes">{{ Min }}</option></select>
                    </div>
                </div> 
                <div class="date-time-box" @change="changeDate"> 
                    <div class="label w-33">
                        <p>Day</p>
                        <select v-model="day"><option v-for="Day in days">{{ Day }}</option></select>
                    </div>    
                    <div class="label w-33">
                        <p>Mth</p>
                        <select v-model="month"><option v-for="Month in months">{{ Month }}</option></select>
                    </div> 
                    <div class="label w-33">
                        <p>Year</p>
                        <select v-model="year"><option v-for="Year in years">{{ Year }}</option></select>
                    </div>                                       
                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="setExpiryDate">save date</p>
            </div>
        </div>
        <Quill v-if="quill" :item="quill" @emit="emit" />
        <div v-if="previewHTML" class="previewHTML ql-snow" style="border:1px solid #c0c0c0">
            <header><p>Preview</p><div class="x" @click="previewHTML = false"></div></header>
            <div class="ql-editor">            
                <div v-html="previewHTML">
                    
                </div>
            </div>
        </div>
    </div>

    </div>

</template>

<script>

import Alert from '@/utils/Alert.js';
import UploadFile from '@/utils/UploadFile.js'
import postMinify from '@/utils/postMinify.js'
import WebSoc from '@/utils/WebSoc.js'
import { format } from 'date-fns' 
import Quill from '@/components/Quill.vue'
import { mapActions, mapMutations } from 'vuex'
//import { VueEditor, Quill } from 'vue2-editor'

import CComp from '../components/Cards/Comp';
import CImage from '../components/Cards/Image'
import CLink from '../components/Cards/Link';
import CQr from '../components/Cards/Qr'
import CRotate from '../components/Cards/Rotate'
import CTerms from '../components/Cards/Terms'
import CText from '../components/Cards/Text'
import CVideo from '../components/Cards/Video';

export default {
    props: ['item'],
    components: {
        Quill,
        CComp,
        CImage,
        CLink,
        CQr,
        CRotate,
        CTerms,
        CText,
        CVideo
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        currentOffers () { return this.$store.state.currentOffers }
    },
    data () { 
        return {
            selectFront: false,
            selectBack: false,
            setExpire: false,
            hideBoxes: false,
            btnType: '',
            types: [ // Link / Terms / Rotate / Qr / Comp / Video / Text / Image
                //{ type: 'back', selected: false, content: { style: '', action: 'back', top: 0, left: 0, width: 90, height: 80, value: '', html: [0,0].map(c => '<div></div>').join('') } },
                //{ type: 'hamburger', selected: false, content: { style: '', action: 'ham', top: 0, left: 0, width: 90, height: 80, value: '', html: [0,0,0].map(c => '<div></div>').join('') } },
                //{ type: 'next', selected: false, content: { style: '', action: 'next', value: '', top: 285, left: 40, width: 334, height: 65 } },
                //{ type: 'step', selected: false,  content: { style: '', action: 'step', value: '', top: 285, left: 40, width: 334, height: 65 } },
                //{ type: 'input', selected: false, content: { style: '', border: false, borderColor: '#ffffff', action: 'input', textarea: true, top: 285, left: 40, width: 334, height: 65, field: '', value: '', placeholder: 'Write your answer here...', error: '' } },
                //{ type: 'select', selected: false, content: { style: '', action: 'select', value: '', options: '', top: 300, left: 40, width: 334, height: 65 } },
                { type: 'link', component: 'CLink', selected: false,  style: '', action: 'link', value: '', top: 300, left: 40, width: 334, height: 65 },
                //{ type: 'location', selected: false, content: { style: '', action: 'location', options: '', value: 'Store', top: 300, left: 40, width: 344, height: 65 } },
                //{ type: 'qr', selected: false, content: { style: '', action: 'qr', options: '', value: '', top: 110, left: 110, width: 180, height: 180 } },
                { type: 'terms', component: 'CTerms', style: '', action: 'terms', value: '', top: 285, left: 40, width: 334, height: 65 },
                { type: 'rotate', component: 'CRotate', selected: false,  style: '', action: 'rotate', top: 376, left: 29, width: 350, height: 90, value: '', contentRotate: { style: '', action: 'rotate', top: 0, left: 0, width: 410, height: 90, value: '' } },
                { type: 'qr', component: 'CQr', selected: false, style: '', action: 'qr', top: 110, left: 110, width: 180, height: 180, value: '' },
                { type: 'comp', component: 'CComp', selected: false,  style: '', action: 'comp', value: '', top: 285, left: 40, width: 334, height: 65 },
                //{ type: 'gif', selected: false, content: { style: '', action: 'gif', top: 90, left: 65, width: 280, height: 280, value: '', gif: '' } },
                { type: 'video', component: 'CVideo', selected: false, fixed: true,  style: '', action: 'video', top: 100, left: 17, width: 380, height: 220, value: '', mov: '' },
                //{ type: 'slider', seleted: false, content: { style: '', action: 'slider', top: 40, left: 20, width: 390, height: 100, value: '', init: 0, step: 1, min: 0, max: 11 } },
                //{ type: 'checkbox', selected: false, content: { style: '', action: 'checkbox', top: 40, left: 20, width: 334, height: 65, background: '' } },
                //{ type: 'stars', selected: false, content: { style: '', action: 'stars', top: 300, left: 40, width: 380, height: 76, background: '', auto: false } },
                //{ type: 'image', selected: false, content: { style: '', action: 'image', top: 300, left: 30, width: 320, height: 320, background: '' } },
                //{ type: 'slider-score', selected: false, content: { style: '', action: 'slider-score', top: 210, left: 30, width: 354, height: 120, background: '' } },
                //{ type: 'quiz-score', selected: false, content: { style: '', action: 'quiz-score', top: 200, left: 30, width: 320, height: 320, background: '' } },
                //{ type: 'quiz-result', selected: false, content: { style: '', action: 'quiz-result', top: 200, left: 100, width: 210, height: 210, background: '', img: '' } }  
                { type: 'text', component: 'CText', selected: false, style: '', action: 'text', top: 0, left: 0, width: 414, height: 100, value: '', fontSize: 35, lineHeight: 1, fontFamily: '', css: '', textAlign: 'center', backgrourColor: '#FFFFFF', fontColor: '#000000' },
                { type: 'image', component: 'CImage', selected: false, style: '', top: 0, left: 0, width: 414  },
                { type: 'background', selected: false, style: '', top: 0, left: 0, width: 414  },
            ],
            cats: [],
            fontSizes: new Array(50).fill(true).map((_,i) => i + 12),
            fontFamilies: [
                { font: 'Sans Serif' },
                { font: 'Solway',  href: "https://fonts.googleapis.com/css2?family=Solway:wght@300;400&display=swap" },
                { font: 'Roboto', href: 'https://fonts.googleapis.com/css?family=Roboto' }
            ],
            fontFamily: 'Sans Serif',
            textAligns: ['center','left','right','justify'],
            fontCSS: '',
            hours: new Array(24).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            minutes: new Array(60).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            days: new Array(31).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            months: new Array(12).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            years: new Array(15).fill(true).map((_,i) => (new Date().getFullYear()-2000)+i),
            hour: '00',
            minute: '00',
            day: '01',
            month: '01',
            bottomless: [
                'immediate',
                '1 Hour',
                '1 day',
                'Monday',
                'Friday',
                '7 days',
                '1st of Month',
                '6 Months',
                '12 Months'
            ],
            year: (new Date().getFullYear() - 2000)+'',
            scale: 0.6763285,
            ad: {
                rotated: false,
                height: 500,
                backgroundColor: '#FFFFFF',
                fontColor: '#000000',
                btns: [],
                bottomless: 'immediate',
                removed: false,
                redeemAd: true,
                expireAd: false,
                u_expires: '',
                expires: false,
                qtyRedeemed: 0,
                qtySent: 0,
                qtyMembers: 0,
                qtyClicks: 0,
                qtyEntries: 0,
                title: '',
                src: '',
                backface: '',
                cat: '',
            },
            downloading: false,
            currentItem: false,
            quill: false,
            html: false,
            previewHTML: false,
            previewContent: '',
            moving: false,
            aKId: "AKIAQGEUICDL4JSPEGWJ",
            AK: "1AlKIocTeHp+R3DC8L8ysMN0/3BAB60/uG3z/Hxr",
            r: "us-west-2"
        }
    },    
    created () {
        console.log('editVideoCard this.item',this.item);
        console.log('editCideoCard client_id',this.item.client_id);
        var item = this.item;
        var ad = this.ad;
        if ( item.title ) {
            Object.keys(ad).forEach(key => {
                ad[key] = JSON.parse(JSON.stringify(item[key]));
            });
            
            if ( !item.copy ) {
                ad._id = item._id;
                this.currentItem = JSON.parse(JSON.stringify(ad));
            }
        }
    },
    mounted () {
        this.getCats();
        var ad = this.ad;
        this.expires = ad.expires;
        if ( ad.expires > 0 ) {
            var date = new Date(ad.expires);
            this.hour = adZ(date.getHours());
            this.minute = adZ(date.getMinutes());
            this.day = adZ(date.getDate());
            this.month = adZ(date.getMonth() + 1);
            this.year = adZ(date.getFullYear() - 2000);
        }

        function adZ(num) { return (num < 9 ? '0' : '')+num }

        this.fontFamilies.forEach(family => {
            family.css = ".font-"+(family.font.replace(/ /g,'').toLowerCase())+"{font-family:'"+family.font+"'}"
            if ( !family.href ) return;
            this.addHead({
                id: 'font-'+family.font,
                t: 'link',
                href: family.href,
                rel: 'stylesheet' 
            });
            if ( document.head.querySelector('style#font-'+family.font) ) return;
            var style = document.createElement('style');
                style.id = 'font-'+family.font;
                style.innerHTML = ".font-"+(family.font.replace(/ /g,'').toLowerCase())+"{font-family:'"+family.font+"'}";
                document.head.appendChild(style);
        })
    },
    methods: {
        uploadVideo ( btn ) {
            document.querySelectorAll('input#video').forEach(i => i.parentElement.removeChild(i));
            var input = document.createElement('input');
                input.id = 'video';
                input.type = 'file';
                input.setAttribute('accept','video/mp4, video/quicktime, video/mov');
                input.onchange = e => {
                    this.UploadFile(e.target.files[0],url => {
                        console.log('url',url);
                        btn.mov = url;
                        input.parentElement.removeChild(input);
                    });
                }
                input.style.display = 'none';
                this.$el.appendChild(input);
                input.click();

        },
        getSignedURL ( cB ) {
            WebSoc.SEND('getSignedURL',{},resp => {
                console.log(resp); cB(resp.signedURL)
            })
        },
        UploadFile ( file, cB ) {

        this.setKeyValue({ k: 'progress', v: 0.01 });

        var Bucket = 'trainer-upload';
        //var Bucket = 'cdn.memberstar.club';

            AWS.config.update({
                accessKeyId: this.aKId,
                secretAccessKey: this.AK,
                region: this.region // eu-west-2 LONDON
            });

            var bucket = new AWS.S3({
                    params: {
                        Bucket
                    }
                });

            var ContentType = file.type.split('/');

            if ( ContentType[1] == 'quicktime' ) ContentType[1] = 'mov';

            console.log('ContentType',ContentType);

            var ran = new Array(10).fill('abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJLKLMNOPQRSTUVWZXYZ').map(c => c[parseInt(Math.random()* 62)]).join('');
            
            var Key = ran+'-'+Date.now()+'.'+ContentType[1];

            console.log('begin upload');

            bucket.upload({
                Key,
                ContentType: ContentType.join('/'),
                Body: file,
                ACL: 'public-read'
            },(e,data) => {
                    if ( e ) console.log('putObject Error',e);
                    this.setKeyValue({ k: 'progress', v: 0 });
                    cB('https://'+Bucket+'.s3.eu-west-2.amazonaws.com/'+Key);
                }
            ).on('httpUploadProgress',(e) => { 
                this.setKeyValue({ k: 'progress', v: e.loaded / e.total });
            });

        },
        moveBtnOrder ( btn, e ) {
            var dir = e.target.classList.contains('up') ? -1 : 1;
            var btns = this.ad.btns;
            var index = btns.indexOf(btn);
            if ( !btns[index+dir] ) return;
            btns.splice(index,1);
            btns.splice(index + dir,0,btn);
        }, 
        updateBtnFont ( btn ) {
            var fontFamily = this.fontFamily;
            btn.fontFamily = fontFamily;
            var fontType = this.fontFamilies.find(f => f.font == fontFamily);
            this.fontCSS = (fontType.css || '').split('{')[0].replace('.','');
            btn.css = this.fontCSS;
        },
        updateBottomless ( ad, e ) {
            ad.redeemAd = !ad.redeemAd;
            console.log('ad.redeemAd',ad.redeemAd);
        },
        updateAdBottomLess ( ad, bottomless ) {
            console.log('updateAd Bottomless',bottomless,ad.bottomless);
        },
        handleImageAdded ( file, Editor, cursorLocation, resetUploader ) {
            console.log('imageAdded',file);
        },
        handleTextChange ( delta, oldDelta, source) {
            console.log('delta',delta);
        },
        saveQuill () {
            console.log('this.quill',this.quill);
            this.quill = false;
        },
        editTerms ( btn ) {

            const saveChanges = ( item ) => {
                this.quill = false;
                WebSoc.SEND({ t: 'updateQuill', data: item },(resp) => {
                    if ( resp._id ) { btn.terms_id = resp._id }
                });
            }

            if ( btn.terms_id ) {
                WebSoc.SEND({ t: 'getQuill', data: { _id: btn.terms_id } },quill => {
                    quill.save = saveChanges;
                    this.quill = quill;
                })
            } else {
                this.quill = {
                    save: saveChanges,
                    html: '<p>Edit you page here</p>',
                }
            }
            
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.quill = false;
            }
            if ( data.action == 'updateHTML' ) {
                this.previewContent = data.HTML;
            }
            if ( data.action == 'showPreview' ) {
                this.previewHTML = this.previewContent;
            }
        },
        save ( ad ) {

            if ( this._save ) return;
            
            console.log('ad._id',ad._id);
            console.log('ad.title',ad.title);
            console.log('this.item.copy',this.item.copy);
            console.log('currentItem',this.currentItem);
            console.log('this.item._id',this.item._id);

            var fonts = ad.btns.filter(b => b.type == 'text').reduce((p,btn) => { !p[btn.fontFamily] && p.push(p[btn.fontFamily] = btn.fontFamily); return p },[])
            ad.fontFamilies = this.fontFamilies.filter(f => fonts.indexOf(f.font) > -1).filter(f => f.href);

            
            if ( !ad.title ) return Alert.message('Each Card must have a title');

            this._save = true;

            if ( ad.cat == 'No Category' ) { ad.cat = '' }

            if ( this.currentItem ) {
                
                var item = this.currentItem;
        
                var update = Object.keys(item).reduce((p,key) => {
                    if ( JSON.stringify(item[key]) != JSON.stringify(ad[key]) ) p[key] = ad[key];
                    return p
                },{});

                this.$emit('emit',{ t: 'edit-card', action: 'exit' })

                if ( Object.keys(update).length == 0 ) return;

                return WebSoc.SEND('update',{ DB: 'cards', _id: ad._id, update: { $set: update } },resp => {
                    console.log('updated')
                })
            }
            
            
            this.item && ( this.item.copy = false );
            
            ad.cat == 'No Category' && ( ad.cat = '' );
            ad.client_id = this.client_id;
            WebSoc.SEND('newCard',{ card: ad },resp => {
                console.log('newCard resp',resp);
                ad._id = resp._id;  
                ad.code = resp.code;
                this.$emit('emit',{ t: 'edit-card', action: 'add-card', ad: ad });            
            });
        },
        startMove ( btn, e ) {
            this.moving = btn;
            this.selectBtn(btn);
            var clientX = e.clientX;
            var clientY = e.clientY;
            var left = btn.left;
            var top = btn.top;
            var width = btn.width;
            var height = btn.height;
            var image = btn.type == 'image';
            
            var scale = this.scale;
            var adBox = e.target.parentElement.parentElement

            const mouseMove = e => {
                e.preventDefault();
                if ( image ) { height = parseInt(getComputedStyle(e.target).height); }
                var Top = top + ( ( ( e.clientY ) - clientY ) / scale )
                if ( Top < 0 ) Top = 0;
                if ( Top + height > this.ad.height ) { 
                    Top = this.ad.height - height 
                } 
                btn.top = parseInt(Top);
                var Left = left + ( ( ( e.clientX ) - clientX ) / scale )
                if ( Left < 0 ) Left = 0;
                if ( Left + width > 412 ) { Left = 412 - width }
                Left = Math.max(0,Left);
                btn.left = parseInt(Left);
                this.updateBtn(btn);
            }

            const mouseUp = e => {
                e.stopPropagation();
                e.preventDefault();
                adBox.removeEventListener('mouseleave',mouseUp);
                adBox.removeEventListener('mouseup',mouseUp);
                this.$el.removeEventListener('mousemove',mouseMove);
                setTimeout(() => {
                    this.moving = false;
                },0);
            }
           

            adBox.addEventListener('mouseleave',mouseUp);
            adBox.addEventListener('mouseup',mouseUp);
            this.$el.addEventListener('mousemove',mouseMove);
        

        },
        setExpiryDate () {
            this.ad.expires = this.expires;
            this.ad.u_expires = format(this.expires,'dd/MM/yy HH:mm');
            this.setExpire = false;
        },
        changeDate () {
            var { hour, minute, day, month, year } = this;
            this.expires = new Date(2000 + parseInt(year),month-1,parseInt(day),parseInt(hour),parseInt(minute)).valueOf();
        },
        checkExpireAd () {
            if ( this.ad.expireAd ) {
                this.setExpire = true;
            } else {
                this.ad.u_expires = '';
                this.ad.expires = false;
            }
        },
        updateKeyBtn ( btn, field, e ) {
            var dir = [40,38].indexOf(e.keyCode);
            if ( dir == -1 ) return;
            e.preventDefault();
            if ( dir == 0 ) dir = -1;
            btn[field] += dir;
            this.updateBtn ( btn );
        },
        select ( type ) {
            switch ( type ) {
                case 'front':
                    this.selectFront = true;
                    this.selectBack = false;
                    break;
                case 'back':
                    this.selectBack = true;
                    this.selectFront = false;
            }  
        },
        upload ( type, e ) {
            if ( !e.target.classList.contains('upload') ) return console.log('!upload type',type);
            this.select(type);
            UploadFile(result => {
                this.downloading = { count: 100, progress: 0 };
                postMinify(result.result,resp => {
                    if ( resp.size ) return console.log('resp.size',resp.size);
                    if ( resp.progress ) { this.downloading.count = resp.progress.total; this.downloading.progress = resp.progress.progress; return; }
                    if ( resp.url ) this.downloading = false;
                    if ( resp.url ) this.ad[type] = resp.url;
                    this.select(type == 'src' ? 'front' : 'back');
                })
            })
        },
        addButton ( side, type ) {
            var btn = JSON.parse(JSON.stringify(this.types.find(b => b.type == type)));
            btn.reverse = side == 'back';
            switch ( btn.type ) {
                case 'text':
                    btn.fontFamily = this.fontFamily;
                    btn.css = this.fontCSS;
                    btn.backgroundColor = this.ad.backgroundColor;
                    btn.fontColor = this.ad.fontColor;
                    break;
                case 'background':
                    return UploadFile(result => {
                        this.downloading = { count: 100, progress: 0 };
                        postMinify(result.result,resp => {
                        if ( resp.size ) return console.log('resp.size',resp.size);
                            if ( resp.progress ) { this.downloading.count = resp.progress.total; this.downloading.progress = resp.progress.progress; return; }
                            if ( resp.url ) {
                                this.downloading = false;
                                this.ad[side == 'back' ? 'backface' : 'src'] = resp.url;
                            }
                        })
                    })
                    break;
                case 'image':
                    return UploadFile(result => {
 
                        var interval = setInterval(() => {
                            progress += 0.005;
                            this.setKeyValue({ k: 'progress', v: progress });
                        },50);

                        var progress = 0.005;
                        this.setKeyValue({ 
                            k: 'interval', 
                            v: interval
                        });
                        
                        postMinify(result.result,resp => {
                            if ( resp.size ) return console.log('resp.size',resp.size);
                            if ( resp.progress ) { return this.setKeyValue({ k: 'progress', v: resp.progress.progress / resp.progress.total }); }
                            if ( resp.url ) {
                                clearInterval(interval);
                                setTimeout(() => {
                                    this.setKeyValue({ k: 'progress', v: 0 });
                                }, 100); 
                                btn.src = resp.url;
                                this.updateBtn(btn);
                                this.ad.btns.push(btn);
                                this.ad.btns.forEach(b => b.selected = b == btn);
                            }
                        })
                    })                    
            }
            this.updateBtn(btn);
            this.ad.btns.push(btn);
            this.ad.btns.forEach(b => b.selected = b == btn);
        },
        updateBtn ( btn ) {
                btn.style = ['top','left','width','height'].map(f => f+':'+btn[f]+'px').join(';');
        }, 
        selectBtn ( btn ) {
            if ( btn.selected && btn == this.moving ) return;
            if ( btn.selected ) {
                btn.selected = false;
                return this.$forceUpdate();
            }
            this.ad.btns.forEach(b => b.selected = b == btn);
            this.fontCSS = btn.css;
            this.fontFamily = btn.fontFamily;
            this.$forceUpdate();
        },
        btnClick ( btn ) {
            console.log('btnClick',btn);
        },
        getCats () {
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { adCats: 1 } },client => {
                this.ad.cat = this.ad.cat || 'No Category';
                this.cats = ['No Category'].concat(client.adCats);
            });
        },
        ...mapActions([
            'addHead'
        ]),
        ...mapMutations([
            'setKeyValue'
        ])
    }
}

</script>

<style lang="scss">

@import "~vue2-editor/dist/vue2-editor.css";
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.snow.css';

.v-alert.create-ad {
    .ad-btns .ad-btn {
        p { font-size: inherit }
    }
}

.up-down {
    background-image: url('/up-down.png');
    width: 27px;
    height: 27px;
    left: -35px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 5px 0px;
} 
.btn-selected {
    .select-label {
        float: left;
        select { width: 120px;float: left; margin-left: 10px; }
        > p { margin-left: 10px; font-size: 10px;}
        .color-box {
            margin-left: 10px;
        }
    }
}
.label {
    .color-box {
        float: left;
        input[type=color] {
            width: 25px;
            height: 30px;
            float: left;
        }
        input {
            width: 80px;
            float: left;

        }
    }
}

.v-alert .label .bottomless-select {
    width: 120px;
    margin: 0px;
    position: relative;
    top: -7px;
    left: 40px;
}

.previewHTML {
    position: absolute;
    top: 30px;
    right: calc(50% - 212px);
    width:414px;
    height: 660px;
    background-color: white;
    z-index: 100;
    .ql-editor {
        overflow-y: scroll;
    }
}
.quillWrapper {
    background-color:rgba(200,0,0,0.3);
    height: 600px;
}

.vue-editor-container {
    height: 600px;
    width: calc(100% - 10px);
    margin: 5px;
}
.v-alert.create-ad .edit-ad-container.no-boxes {
    .ad-box {
        .ad-btns {
            .ad-btn {
                background-color: rgba(200,0,0,0);
                &.selected {
                    transform: translate(0px,0px);
                    border: 0px;
                    background-color: rgba(200,0,0,0);
                }
            }
        }
    }
}
.v-alert.create-ad {
   .ad-box {
       transform-origin: 0px 0px;
       transform: scale(0.675);
        .ad-btns {
            position: absolute;
            top: 0px;
            left: 0px;
            transform-origin: 0px;
            .ad-btn {
                position: absolute;
                background-color: rgba(200,0,0,0.4);
                display:flex;
                align-items:center;
                justify-content:space-around;
                &.selected {
                    transform: translate(-1px,-1px);
                    border: 1px solid red;
                    background-color: rgba(200,0,0,0.6);
                }
            }
        }
   } 
   .edit-ad-container {
       display: grid;
       grid-template-columns: 300px 1fr;
       .background,.backface {
           width: 280px;
           height: 338px;
           border: 1px solid #c0c0c0;
           margin: 5px;
           float: left;
           &.selected-xxx {
               border: 5px solid red;
               transform: translate(-5px,5px);
           }
           > p.btn { width: calc(100% - 10px); margin-top: calc(50% - 15px);  }
       }
       .btn-list {
           display: grid;
           grid-template-columns: 40px 90px 90px 100px 100px 100px 100px 100px 60px;
           margin-top: 10px;
           position: relative;
           float: left;
           input {
               position: relative;
               left: -6px;
               top: -5px;
           }
           .x {
               position: relative;
               transform: scale(0.5) translateY(-5px);
               height: 0px;
           }
       }
   }
}

</style>